import { resolveImage as r } from "../../../helpers/index.js";
const p = (e) => e.contentType?.includes("section") ? {
  variant: "banner",
  title: e.properties?.header,
  subtitle: e.properties?.title,
  teaser: e.properties?.teaser,
  image: e.properties?.image?.[0] && r(e.properties?.image, !0, "banner")
} : e.contentType?.includes("article") ? {
  variant: "article",
  title: e.properties?.header,
  teaser: e.properties?.teaser,
  image: e.properties?.image?.[0] && {
    ...r(e.properties?.image, !0, "landscape"),
    caption: e.properties?.image?.[0] && e.properties?.imageCaption
  },
  authorByline: {
    byline: e.properties?.byline,
    date: new Date(e.properties?.date)
  },
  subject: e.properties?.subject,
  articleType: e.properties?.articleType
} : {
  variant: "classic",
  title: e.properties?.header,
  subtitle: e.properties?.title,
  teaser: e.properties?.teaser,
  image: e.properties?.image?.[0] && r(e.properties?.image, !0, "landscape")
};
export {
  p as pageTopDeliveryApiParser
};
